<div class="main" [@pageAnimations]="animationState" (@pageAnimations.start)="animationsStart($event)" (@pageAnimations.done)="animationsDone($event)">
  <router-outlet #o="outlet"></router-outlet>
  <div class="overlay"></div>
</div>
<sdx-opacity-layer></sdx-opacity-layer>
